import * as React from "react";
const SvgFiRrEyes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-eyes_svg__a)">
      <path
        fill="#062147"
        d="M17.5 0c-2.346 0-4.359 2.19-5.5 5.54C10.859 2.19 8.846 0 6.5 0 2.855 0 0 5.271 0 12s2.855 12 6.5 12c2.346 0 4.359-2.19 5.5-5.54 1.141 3.35 3.154 5.54 5.5 5.54 3.645 0 6.5-5.271 6.5-12S21.145 0 17.5 0m-11 22c-1.48 0-3.075-1.988-3.911-5.178.283.111.589.178.911.178C4.879 17 6 15.879 6 14.5S4.879 12 3.5 12c-.559 0-1.07.191-1.487.502C2.009 12.334 2 12.171 2 12 2 6.106 4.372 2 6.5 2S11 6.106 11 12 8.628 22 6.5 22m11 0c-1.48 0-3.075-1.988-3.911-5.178.283.111.589.178.911.178 1.379 0 2.5-1.121 2.5-2.5S15.879 12 14.5 12c-.559 0-1.07.191-1.487.502-.004-.168-.013-.331-.013-.502 0-5.894 2.372-10 4.5-10S22 6.106 22 12s-2.372 10-4.5 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-eyes_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEyes;
